module.exports = __webpack_public_path__ + "img/box_icons.73441af4.png";